import { toMetricNumber } from './normalize';
import { MetricV2Data } from './types';

/** v2 payload: target from `total` only. */
export function getTargetFromMetricData(metricData: MetricV2Data | undefined | null): number | undefined {
  if (metricData == null) {
    return undefined;
  }
  return metricData.total;
}

/** Edit UI: read `total` from untyped goal/dataSource rows; callers gate on automateTargetFlag. */
export function getAutomatedTargetFromMetricData(
  metricData: Record<string, unknown> | MetricV2Data | undefined | null,
): number | undefined {
  if (metricData == null || typeof metricData !== 'object') {
    return undefined;
  }
  return toMetricNumber((metricData as Record<string, unknown>).total);
}
